import React, { useState } from "react";
import clsx from "clsx";
import { Typography } from "@material-ui/core";
import ChevronDownIcon from "@material-ui/icons/KeyboardArrowDown";
import useStyles from "./Eans.styles";

export default function Eans({ eans, codigoEAN }) {
  const classes = useStyles();
  const [aberto, setAberto] = useState(false);

  const lista = eans && eans.length > 0 ? eans : [codigoEAN];
  const principal = lista[0];
  const secundarios = lista.slice(1);

  return (
    <>
      <Typography variant="body2" className={classes.linha}>
        <span>
          <b>EAN:</b> {principal}
        </span>
        {secundarios.length > 0 && (
          <ChevronDownIcon
            fontSize="small"
            className={clsx(classes.chevron, {
              [classes.chevronAberto]: aberto,
            })}
            onClick={() => setAberto(!aberto)}
          />
        )}
      </Typography>
      {aberto && (
        <Typography variant="body2">
          <b>EANs secundários:</b> {secundarios.join(", ")}
        </Typography>
      )}
    </>
  );
}
